import _slicedToArray from "/mnt/c/Users/Yeray/game-workspace/migasgame/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function parseQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (query === null) {
    query = window.location.search;
  }

  if (query[0] === '?') query = query.substr(1);
  var dest = {};

  var _iterator = _createForOfIteratorHelper(query.split('&')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var kv = _step.value;

      var _kv$split$map = kv.split('=').map(function (v) {
        return decodeURIComponent(v);
      }),
          _kv$split$map2 = _slicedToArray(_kv$split$map, 2),
          key = _kv$split$map2[0],
          value = _kv$split$map2[1];

      dest[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return dest;
}

export function bindWebStellarLinkHandler(albedoIntent) {
  if (typeof document === 'undefined' || !document.addEventListener) return;
  document.addEventListener('click', function sep0007Handler(e) {
    //we are only interested in links with "web+stellar" protocol
    if (e.target.tagName !== 'A' || (e.target.href || '').indexOf('web+stellar:') !== 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var _URL = new URL(e.target.href),
        intentName = _URL.pathname,
        search = _URL.search;

    if (!['tx', 'pay'].includes(intentName)) {
      alert("Invalid operation requested: ".concat(intentName, ". It's likely an external application error. Please contact support team of ").concat(window.location.origin, "."));
      return;
    }

    var params = parseQuery(search);
    albedoIntent.request(intentName, params);
  }, false);
}